var DailyBlommm = {
  // Main variables
  blommmekes: {
    s: null,
    m: null,
    l: null
  },
  ready: 0,

  // Main methods
  init: function(){
    var self = this;
    this.DateTime.init();
    this.loadProducts();
  },

  // load Shopify products with Ajax
  loadProducts: function(){
    var self = this;
    $.getJSON('/products/blommmeke-s.js', function(product) {
      self.blommmekes.s = product;
      self.Today.init();
      self.Reservations.init();
    });
    $.getJSON('/products/blommmeke-m.js', function(product) {
      self.blommmekes.m = product;
      self.Today.init();
      self.Reservations.init();
    });
    $.getJSON('/products/blommmeke-l.js', function(product) {
      self.blommmekes.l = product;
      self.Today.init();
      self.Reservations.init();
    });
  },

  getVariant: function(variants, todayString){
    var v = false;
    variants.forEach(function(variant){
      if(variant.title === todayString) v = variant;
    });
    return v;
  },
  makeProductCards: function(products, day){
    var self = this;
    var html = '';
    products.forEach(function(product){
      var c = self.makeProductCard(product, day);
      if(c) html += c;
    });
    if(html !== '') {
      return html;
    } else {
      return false;
    }
  },
  makeProductCard: function(p, d){
    var v = this.getVariant(p.variants, d);
    if(v) {
      var product = this.makeProduct(p, v);
      var price = '';
      if(product.price) {
        price = product.price.toString().slice(0, -2);
        if (product.price.toString().slice(-2) !== '00') price += ',' + product.price.toString().slice(-2);
      }
      var output ='';
      output += '<div class="grid__item medium-up--one-third">\n'
      output += '\t<div class="grid-view-item grid-view-item-simple';
      if(!product.available) output += ' product-price--sold-out grid-view-item--sold-out';
      output += '">\n';
      if(product.available) output += '\t\t<a class="grid-view-item__link" href="/products/' + product.handle + '?variant=' + product.vid + '">\n';
      output += '\t\t<div class="h4 grid-view-item__title">' + product.title + '</div>\n';
      output += '\t\t\t<div class="grid-view-item__meta">\n';
      output += '\t\t\t\t<span class="product-price__price">€ ' + price + '</span>\n';
      output += '\t\t\t</div>\n';
      output += '\t\t\t<div class="grid-view-item__meta">\n';
      if(product.available) {
        output += '\t\t\t<button class="btn">Bestellen</button>\n';
      } else {
        output += '\t\t\t<button class="btn" disabled>Uitverkocht</button>\n';
      }
      output += '\t\t</div>\n';
      if(product.available) output += '\t</a>\n';
      output += '\t</div>\n';
      output += '\t</div>\n';
      return output;
    } else {
      return false;
    }
  },
  makeProduct: function(product, variant){
    return {
      pid: product.id,
      vid: variant.id,
      title: product.title,
      handle: product.handle,
      price: variant.price,
      available: variant.available
    }
  },

  // DateTime helper object
  DateTime: {
    // variables
    now: null,
    tomorrow: null,
    todayString: null,
    tomorrowString: null,
    day: null,
    hour: null,
//    debugTS: 1495100220000, // 05/18/2017 11:37:00, disable on production!

    // methods
    init: function(){
      this.now = new Date();
      if(this.debugTS) {
        this.now = new Date(this.debugTS);
      }
      var ts = this.now.getTime() + (24 * 60 * 60 * 1000); // hours * minutes * seconds * milliseconds
      this.tomorrow = new Date(ts);
      this.todayString =  this.toDateString(this.now);
      this.tomorrowString = this.toDateString(this.tomorrow);
      this.day = this.now.getDay();
      this.hour = this.now.getHours();
      if(this.debugTS) {
        console.warn('DailyBlommm.DateTime is operating in debug mode!');
        console.log('Today is ' + this.todayString);
        console.log('The hour is ' + this.hour);
        console.log('Tomorrow is ' + this.tomorrowString);
      }
    },
    toDateString: function(date){
    return ("0" + date.getDate()).slice(-2) + '/' + ("0" + (date.getMonth() + 1)).slice(-2) + '/' + date.getFullYear();
    },
    isSameSchedule: function(h1, h2) {
      return ( 4 < h1 && h1 < 13 ) === ( 4 < h2 && h2 < 13 );
    }
  },

  // Daily section
  Today: {
    // variables
    blommmekes: {
      all: {
        s: null,
        m: null,
        l: null
      }
    },
    wrapper: null,
    closedWrapper: null,
    loading: false,
    closed: false,
    pollingInterval: 300000, // 5 mins
    isPolling: false,

    // methods
    init: function(){
      var self = this;
      if(this.wrapper === null) {
        this.wrapper = $('.collection-daily').first();
      }
      if(this.closedWrapper === null) {
        this.closedWrapper = $('.collection-daily-closed-msg').clone();
      }
      if(DailyBlommm.DateTime.now === null) {
        DailyBlommm.DateTime.init();
      }
      if(DailyBlommm.DateTime.day > 1 && DailyBlommm.DateTime.day < 6 && DailyBlommm.DateTime.hour < 13) {
        this.openShop();
      } else {
        this.closeShop();
      }
      this.wrapper.attr('data-checked-date', DailyBlommm.DateTime.todayString)
      this.wrapper.attr('data-checked-hour', DailyBlommm.DateTime.hour);
      // start polling for changes
      if(!this.isPolling) {
        this.isPolling = window.setInterval(function(){
          self.shouldReload();
        }, self.pollingInterval);
      }
    },
    openShop: function(){
      if(!this.loading) {
        this.wrapper.html('<h2>De Blommmekes worden geladen...</h2>\n');
        this.loading = true;
      }
      if(    
           DailyBlommm.blommmekes.s !== null 
        && DailyBlommm.blommmekes.m !== null 
        && DailyBlommm.blommmekes.l !== null
      ){
        this.closed = false;
        this.makeDailySection();
      }

    },
    // show "Shop closed" message
    closeShop: function(){
      if(!this.closed) {
        console.log('closing shop');
        this.closedWrapper.removeClass('hidden');
        this.wrapper.empty().append(this.closedWrapper);
        this.closed = true;
      }
    },
    makeDailySection: function() {
      if(DailyBlommm.DateTime.now === null) DailyBlommm.DateTime.init();
      var todayStringCards = DailyBlommm.makeProductCards([
        DailyBlommm.blommmekes.s,
        DailyBlommm.blommmekes.m,
        DailyBlommm.blommmekes.l
      ], DailyBlommm.DateTime.todayString);
      if(todayStringCards) {
        var html = '<h2>Blommmeke van de dag</h2>\n';
        html += '<div class="grid grid--uniform grid--view-items">\n';
        html += todayStringCards;
        if(this.day === 5) {
          var tomorrowStringCards = DailyBlommm.makeProductCards([
            DailyBlommm.blommmekes.s,
            DailyBlommm.blommmekes.m,
            DailyBlommm.blommmekes.l
          ], DailyBlommm.DateTime.tomorrowString);
          html += '</div>\n';
          html += '<h2>Blommmeke voor zaterdag</h2>\n';
          html += '<div class="grid grid--uniform grid--view-items">\n';
          html += tomorrowStringCards;
        }
        html += '</div>\n';
        this.wrapper.html(html);
      } else {
        this.closeShop();
      }
    },
    shouldReload: function(){
      DailyBlommm.DateTime.init();
      var lastDate = this.wrapper.attr('data-checked-date');
      var lastHour = this.wrapper.attr('data-checked-hour');
      var currentDate = DailyBlommm.DateTime.todayString;
      var currentHour = DailyBlommm.DateTime.hour;
      var isSameSchedule = DailyBlommm.DateTime.isSameSchedule(lastHour, currentHour);
      if(lastDate !== currentDate || (lastDate === currentDate && !isSameSchedule)) {
        console.log("Reloading Daily Blommmekes");
        this.init();
      }
    }
  },

  // Reservations section
  Reservations: {
    // variables
    wrapper: null,
    formatWrapper: null,
    formatPicker: null,
    dateWrapper: null,
    datePicker: null,
    btnWrapper: null,
    button: null,
    selectedFormat: null,
    selectedDate: null,
    pikaday: null,

    // methods
    init: function(){
      if(    
           DailyBlommm.blommmekes.s !== null 
        && DailyBlommm.blommmekes.m !== null 
        && DailyBlommm.blommmekes.l !== null
      ){
        this.wrapper = $('.collection-daily-reservations');
        this.formatWrapper = this.wrapper.find('.format-wrapper');
        this.formatPicker = $('#reserve-blommmeke-format');
        this.dateWrapper = this.wrapper.find('.date-wrapper');
        this.datePicker = $('#reserve-blommmeke-date');
        this.btnWrapper = this.wrapper.find('.btn-wrapper');
        this.button = this.wrapper.find('button');
        if(DailyBlommm.DateTime.tomorrow === null) DailyBlommm.DateTime.init();
        this.pikaday = new Pikaday({ 
          field: this.datePicker[0],
          firstDay: 1,
          minDate: DailyBlommm.DateTime.tomorrow,
          disableDayFn: this.filterBlommmDays,
          i18n: {
            previousMonth : 'vorige maand',
            nextMonth     : 'volgende maand',
            months        : ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
            weekdays      : ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
            weekdaysShort : ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
          },
          format: 'DD/MM/YYYY',
          theme: 'blommm-pika'
        });
        this.addEventListeners();
      }
    },
    filterBlommmDays(date){
      var day = date.getDay();
      return(day < 2 || day > 6);
    },
    addEventListeners: function(){
      var self = this;
      this.formatPicker.on('change',function(e){
        self.selectedFormat = e.target.value;
        if(self.selectedFormat) {
          self.dateWrapper.removeClass('hidden');
          self.button.text('Controleer de beschikbaarheid');
        } else {
          self.dateWrapper.addClass('hidden');
        }
      });
      this.datePicker.on('change', function(e){
        self.selectedDate = e.target.value;
        if(self.selectedDate) {
          self.checkAvailability();
          self.btnWrapper.removeClass('hidden');
        } else {
          self.button.attr('disabled', true);
          self.btnWrapper.addClass('hidden');
        }
      });
    },
    checkAvailability: function(){
      if(this.selectedFormat !== null && this.selectedDate !== null) {
        var variants = DailyBlommm.blommmekes[this.selectedFormat].variants;
        var variant = DailyBlommm.getVariant(variants, this.selectedDate);
        if(variant && variant.available) {
          this.setResult(variant.id);
        } else {
          this.setResult(false);
        }
      }
    },
    setResult: function(id) {
      this.button.removeClass('hidden');
      if(id) {
        var self = this;
        this.btnWrapper.find('label').text('We hebben een Blommmeke gevonden!')
        this.button.text('Bestel je Blommmeke');
        this.button.attr('disabled', false);
        this.button.off('click');
        this.button.on('click', function(addEventListeners){
          var url = location.protocol + '//';
          url += location.host;
          url += '/products/blommmeke-';
          url += self.selectedFormat;
          url += '?variant=' + id;
          location = url;
        })
      } else {
        this.btnWrapper.find('label').text('Probeer een andere datum.')
        this.button.text('Geen Blommmeke beschikbaar');
        this.button.attr('disabled', true);
      }
    }
  }
}
$(document).ready(DailyBlommm.init.bind(DailyBlommm));